import { ProcessHeader } from "../components/process/ProcessHeader";
import { PhaseWorkflow } from "../components/process/PhaseWorkflow";

export default function Process() {
    return (
        <main data-testid="process-page" className="bg-[#FAFAFA]">
            <ProcessHeader />
            <PhaseWorkflow />
        </main>
    );
}
